module.exports = __webpack_public_path__ + "img/wz-5-3.85109d7c.png";